import { Breadcrumbs } from '@frontend/breadcrumbs';
import { Outlet, useLocation } from 'react-router-dom';

export function AdminRouteLayout() {
    const location = useLocation();
    const showBreadcrumbs = location.pathname !== '/';

    return (
        <>
            {showBreadcrumbs && (
                <div
                    id='main-admin-breadcrumbs'
                    className='mb-6 inline-flex w-full items-center justify-start gap-2 self-stretch'>
                    <Breadcrumbs />
                </div>
            )}
            <Outlet />
        </>
    );
}

export default AdminRouteLayout;
